export * from './core/index';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core.ts